const { TRIAL_TARIFF_DAYS_DURATION } = require('../appConstants');
const {
    lite2024CommonName,
    professional2024CommonName,
    expert2024CommonName,
    ultimate2025CommonName,
} = require('./common-book-tariffs');

module.exports = {
    ULTIMATE_2025: {
        name: ultimate2025CommonName,
        description: `La scelta ideale se desideri qualcosa di unico e vuoi utilizzare Zenamu senza alcuna limitazione`,
    },
    EXPERT_2024: {
        name: expert2024CommonName,
        description:
            'Sono un esperto indipendente o uno studio con un team di due o più istruttori. La nostra offerta include una vasta gamma di lezioni, workshop specializzati e corsi tematici regolari.',
    },
    PROFESSIONAL_2024: {
        name: professional2024CommonName,
        description:
            'Ho un’attività consolidata e clienti fedeli che tornano frequentemente. Organizzo più lezioni a settimana e corsi a lungo termine con più sessioni.',
    },
    LITE_2024: {
        name: lite2024CommonName,
        description: `Organizzo lezioni settimanali regolari e, occasionalmente, workshop specializzati nei fine settimana. Le mie lezioni sono rivolte a partecipanti regolari.`,
    },
    TRIAL_FREELANCER: {
        name: 'Versione di prova con funzionalità illimitate',
        description: `Prova l'abbonamento "Insegnante individuale" gratuitamente per ${TRIAL_TARIFF_DAYS_DURATION} giorni con una nuova registrazione.`,
    },
    TRIAL_STUDIO: {
        name: 'Versione di prova con funzionalità illimitate',
        description: `Prova l'abbonamento "Studio" gratuitamente per ${TRIAL_TARIFF_DAYS_DURATION} giorni con una nuova registrazione.`,
    },
    FREE: {
        name: 'Principiante',
        description:
            'Organizzo lezioni in modo irregolare e piuttosto occasionale. Tengo solo alcune lezioni al mese per un piccolo gruppo di partecipanti.',
    },

    FREELANCER_2024_COMPATIBILITY: {
        name: 'Professionista',
        description: `Sono un insegnante. Organizzo lezioni aperte, corsi o workshop.`,
    },
    STUDIO_2024_COMPATIBILITY: {
        name: 'Studio',
        description: `Organizziamo corsi, lezioni aperte o workshop condotti da diversi insegnanti.`,
    },
    STUDIO_PRO_2024_COMPATIBILITY: {
        name: 'Studio PRO',
        description: `Organizziamo corsi, lezioni aperte o workshop condotti da diversi insegnanti.`,
    },
};
